module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'Statuses') ? _c('div', [_c('admin-filter', {
    model: {
      value: (_vm.filterParams),
      callback: function($$v) {
        _vm.filterParams = $$v
      },
      expression: "filterParams"
    }
  }), _vm._v(" "), _c('admin-card', [_c('template', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n      Список статусов\n      "), _c('router-link', {
    staticClass: "pull-right btn btn-primary btn-sm",
    attrs: {
      "to": {
        name: 'StatusCreate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Добавить\n      ")])], 1), _vm._v(" "), _c('admin-list', {
    attrs: {
      "items": _vm.items,
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "col-6 col-md-4"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-1"
        }, [_vm._v("\n            " + _vm._s(item.code) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-1"
        }, [_vm._v("\n            " + _vm._s(item.class) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-1"
        }, [_vm._v("\n            " + _vm._s(item.sort) + "\n          ")]), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-1"
        }, _vm._l((item.amoStatuses), function(amoStatus) {
          return _c('span', {
            staticClass: "badge badge-info text-muted small"
          }, [_vm._v(_vm._s(amoStatus.name))])
        })), _vm._v(" "), _c('div', {
          staticClass: "col-6 col-md-2"
        }, [_c('router-link', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "to": {
              name: 'StatusEdit',
              params: {
                id: item.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(" Изменить\n            ")])], 1)]
      }
    }])
  }, [_c('template', {
    attrs: {
      "slot": "headerList"
    },
    slot: "headerList"
  }, [_c('div', {
    staticClass: "col-6 col-md-4"
  }, [_vm._v("Название")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-1"
  }, [_vm._v("Код")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-1"
  }, [_vm._v("Класс")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-1"
  }, [_vm._v("Сортировка")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-1"
  }, [_vm._v("Id статусов в AmoCrm")]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-2"
  }, [_vm._v("Управление")])])], 2)], 2)], 1) : _c('router-view')
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-35db23a4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-35db23a4"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Admin/Statuses/StatusList.vue
// module id = 1027
// module chunks = 1